export default __webpack_public_path__ + "static/media/action.bfa1fa76.svg";